<template>
	<NotificationCard
		v-if="!isBrowserSupported"
		title="Browser niet ondersteund"
		type="error"
	>
		De browser die je gebruikt wordt niet ondersteund, de applicatie werkt mogelijk niet correct. <br />
		Update je browser naar de laatste versie of gebruik een moderne browser zoals Chrome, Firefox, Safari of Edge.
	</NotificationCard>
</template>

<script lang="ts" setup>
	import {computed} from 'vue';
	import NotificationCard from '~/components/generic/NotificationCard.vue';

	const isBrowserSupported = computed(() => {
		try {
			// Check if URL.canParse is available (Safari 17+, Baseline 2023 feature supported by all "modern" browsers)
			if (typeof URL.canParse !== 'function') {
				console.error('[BrowserSupport] URL.canParse not available (Safari 17+ required)');
				return false;
			}

			// Check if randomUUID is available - Used by Keycloak
			if (typeof window.crypto.randomUUID !== 'function') {
				console.error('[BrowserSupport] crypto.randomUUID not available');
				return false;
			}
			// Check if toSorted is available - Used in various places in our application
			const testArray = [3, 1, 2];
			if (typeof testArray.toSorted !== 'function' ||
				JSON.stringify(testArray.toSorted()) !== JSON.stringify([1, 2, 3])) {
				console.error('[BrowserSupport] Array.prototype.toSorted not available or not working as expected');
				return false;
			}
			return true;
		} catch (e) {
			console.error('[BrowserSupport] Browser support check failed:', e);
			return false;
		}
	});
</script>
